import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import DOMPurify from "dompurify";



const TapHelper         =   {

    arraySumByKey           :   function(arr, key) {
        return arr.length === 0 
            ? 0 
            :  arr.reduce((accumulator, object) => {
                return parseFloat(accumulator) + ((key in object && object[key] !== null) ? parseFloat(object[key]) : 0);
            }, 0);
    },

    pick                :   function(obj, arr) {
        return arr.reduce((acc, record) => (record in obj && (acc[record] = obj[record]), acc), {});
    },


    firstStringPlusFormatter    :   function(arr) {
        if(arr.length === 0 ) {
            return '';
        } else {
            let text            =   arr[0];
            if(arr.length > 1) {
                text           +=   ' (+' + (parseInt(arr.length) - 1) + ')' ;
            }
            return text;
        }
    },

    numberFormatter              :   function(number, precision=2) {
        let parsedNumber            =   parseFloat(number);
        if (!isNaN(parsedNumber)) {
            return parseFloat(parsedNumber.toFixed(precision)); 
        }
        return ''
    },

    dispayAsAmount              :   function(num) {
        return this.numberFormatter(num,2);
    },

    textTruncate                :   function(str, length = 100, ending="...") {
        if (str && (str.length > length)) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    },

    range                :   function(a, b, step=1) {
        var A = [];
        if(typeof a == 'number'){
            A[0] = a;
            step = step || 1;
            while(a+step <= b){
                A[A.length]= a+= step;
            }
        }
        else {
            var s = 'abcdefghijklmnopqrstuvwxyz';
            if(a === a.toUpperCase()){
                b = b.toUpperCase();
                s = s.toUpperCase();
            }
            s = s.substring(s.indexOf(a), s.indexOf(b)+ 1);
            A = s.split('');        
        }
        return A;
    },

    chunkArray                  :   function(arr, chunkSize) {
        let chunkedArr                  =   [];
        if(chunkSize > 0) {
            for (let i = 0; i < arr.length; i += chunkSize) {
                chunkedArr.push(arr.slice(i, i + chunkSize));
            }
        } else {
            chunkedArr              =   arr;
        }
        return chunkedArr;
    },

    encrypt                 :   function(str) {
        //return CryptoJS.AES.encrypt(str, process.env.REACT_APP_KEY).toString();
        let data                =   CryptoJS.AES.encrypt(str, process.env.REACT_APP_KEY).toString();
        return data;
    },
    
    decrypt : function(str) {
        if (!str) return null;
        try {
            const bytes = CryptoJS.AES.decrypt(str, process.env.REACT_APP_KEY);
            return bytes.toString(CryptoJS.enc.Utf8);
        } catch (err) {
            return null;
        }
    },


    cookiesSet : function(name, value, days = 10) {
        let isProd                  =   process.env.REACT_APP_ENV === "production";
        let options                 =   {
            path                        :   "/",                        // ✅ available everywhere
            expires                     :   days,                       // ✅ days
            sameSite                    :   isProd ? "Strict" : "Lax",  // ✅ prevent CSRF from other sites
            secure                      :   isProd,                     // ✅ required true for HTTPS
        };
        if (isProd) {
            options.domain          =   process.env.REACT_APP_DOMAIN    // ✅ root domain, works on subdomains
        }

        Cookies.set(name, value, options);
    },

    cookiesRemove : function(name) {
        let isProd                  =   process.env.REACT_APP_ENV === "production";
        let options                 =   {
            path                        :   "/",                        // ✅ available everywhere
        };
        if (isProd) {
            options.domain          =   process.env.REACT_APP_DOMAIN    // ✅ root domain, works on subdomains
        }
        Cookies.remove(name, options);
    },

    cookiesGet : function(name) {
        return Cookies.get(name);
    },
    
    clearAllCookies : function() {
        const allCookies            =   Cookies.get(); // returns object of all cookies
        Object.keys(allCookies).forEach(cookieName => {
            this.cookiesRemove(cookieName);
        });
    },


    sanitizeObject : function(obj) {
        if (typeof obj === "string") {
            // return DOMPurify.sanitize(obj);
            return DOMPurify.sanitize(obj, { FORBID_TAGS: ["iframe", "script", "iframe"] });
        } else if (Array.isArray(obj)) {
            return obj.map(TapHelper.sanitizeObject);
        } else if (typeof obj === "object" && obj !== null) {
            const cleanObj = {};
            for (const key in obj) {
                cleanObj[key] = TapHelper.sanitizeObject(obj[key]);
            }
            return cleanObj;
        }
        return obj; // numbers, booleans, null, etc.
    },

    darkenColor : function(hex, amount = 30) {
        hex = hex.replace('#', '');

        const num = parseInt(hex, 16);

        let r = (num >> 16) & 255;
        let g = (num >> 8) & 255;
        let b = num & 255;

        r = Math.max(0, r - amount);
        g = Math.max(0, g - amount);
        b = Math.max(0, b - amount);

        return `#${((1 << 24) | (r << 16) | (g << 8) | b)
            .toString(16)
            .slice(1)}`;
    },
    setPasscodeToken: function (token) {
        this.cookiesSet("passcode_access_token", this.encrypt(token));
    },

    getPasscodeToken: function () {
        return this.decrypt(this.cookiesGet("passcode_access_token"));
    },

    removePasscodeToken: function () {
        this.cookiesRemove("passcode_access_token");
    },

    setPasscodeExpiry: function (expiry) {
        this.cookiesSet("passcode_expiry", this.encrypt(String(expiry)));
    },

    getPasscodeExpiry: function () {
        return this.decrypt(this.cookiesGet("passcode_expiry"));
    },

    removePasscodeExpiry: function () {
        this.cookiesRemove("passcode_expiry");
    },

    setPasscodeDeviceId: function (deviceId) {
        this.cookiesSet(
            "device_id_passcode",
            this.encrypt(deviceId)
        );
    },

    getPasscodeDeviceId: function () {
        return this.decrypt(
            this.cookiesGet("device_id_passcode")
        );
    },

    removePasscodeDeviceId: function () {
        this.cookiesRemove("device_id_passcode");
    },

};

export default TapHelper;